import homepage_background from "../../media/homepage_background.svg";
import full_logo from "../../media/full_logo.svg";
import { Card, CardContent } from "../../component/ui/Card";
import { Image } from "@fluentui/react";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
    const navigate = useNavigate();

    const services = [
        {
            title: "Feasibility Studies / Project Design",
            image: "/wind-turbines.jpg",
            items: [
                "Site Assessment",
                "Resource Analysis",
                "Conceptual Design",
                "Detailed Engineering",
            ],
        },
        {
            title: "Grid Integration / Interconnection Studies",
            image: "/solar-panels.jpg",
            items: [
                "Financial Modeling, Cost Estimation",
                "Power Flow, Stability, Short Circuit Analysis",
                "Interconnection Studies",
                "Grid Enhancing Technologies (GET)",
            ],
        },
        {
            title: "Electricity Market Forecasting",
            image: "/power-lines.jpg",
            items: [
                "SCED Analysis",
                "Curtailment and Congestion Risk Assessment",
                "CRR/FTR Strategies",
            ],
        },
    ];

    return (
        <div className="max-h-screen overflow-y-scroll bg-gray-200 dark:bg-gray-900">
            <div
                className="relative h-[50dvh] bg-cover bg-center"
                style={{ backgroundImage: `url(${homepage_background})` }}
            >
                <div className="absolute inset-0 flex flex-col h-full items-center justify-center bg-white bg-opacity-50">
                    <Image src={full_logo} width={200} />
                    <span className="text-lg -mb-1 text-[#006A66]">
                        Transforming{" "}
                        <span className="font-bold italic">GRID</span>
                    </span>
                    <span className="text-lg mb-2 text-[#006A66]">
                        with Data-Driven{" "}
                        <span className="font-bold italic">INSIGHTS</span>
                    </span>
                    <span className="text-2xl font-bold mb-8 w-1/4 align-center text-center text-[#006A66]">
                        Enhancing Sustainability through Innovation
                    </span>

                    <button
                        className="px-[12px] h-[40px] rounded-[3px] bg-accent1 hover:bg-accent2 duration-300 text-white dark:text-[#CEE0EF] dark:hover:text-white text-lg font-semibold"
                        onClick={() => navigate("/transmission-insights")}
                    >
                        Open Transmission Insights
                    </button>
                </div>
            </div>

            <div className="container mx-auto px-4 py-16 h-[50dvh]">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {services.map((service, index) => (
                        <Card key={index} className="bg-gray-800 text-white">
                            <CardContent className="p-6 border-none">
                                <div
                                    className="h-48 mb-4 bg-cover bg-center rounded-t"
                                    style={{
                                        backgroundImage: `url(${service.image})`,
                                    }}
                                />
                                <h3 className="text-xl font-semibold mb-4 text-green-400">
                                    {service.title}
                                </h3>
                                <ul className="space-y-2">
                                    {service.items.map((item, idx) => (
                                        <ul>
                                            <li
                                                key={idx}
                                                className="flex items-center"
                                            >
                                                <span className="w-2 h-2 rounded-full mr-2" />
                                                {item}
                                            </li>
                                        </ul>
                                    ))}
                                </ul>
                            </CardContent>
                        </Card>
                    ))}
                </div>
            </div>

            {/* TESTIMONIAL SECTION; leaving empty until there are testimonials */}
            {/* <div className="h-[33dvh] bg-[#006A66]">
            </div> */}

            {/* REQUEST FORM & FOOTER SECTION; leaving empty until form style and details about company are discussed */}
            {/* <div className="h-[67dvh]">
            </div> */}
        </div>
    );
};

export default HomePage;
